const LogoIcon = () => {
    return (
        <svg
            width="12"
            height="24"
            viewBox="0 0 12 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M11.913 0C10.0764 0 8.58772 1.28631 8.58772 2.87275V6.81596H1.65652C0.741073 6.81596 0 7.45931 0 8.25234V21.1193C0 22.7061 1.48215 23.9928 3.31303 23.9928V18.5902H10.2403C11.1558 18.5902 11.9008 17.9468 11.9008 17.153V0.00538687M8.59383 15.8267H3.31913V9.78568H8.59383V15.8267Z"
                fill="#05668D"
            />
            <path
                d="M12 0C10.15 0 8.65047 1.28633 8.65047 2.87327V6.8181H1.66862C0.746487 6.8181 0 7.46165 0 8.25455V21.1256C0 22.7133 1.49297 24 3.33724 24V18.596H10.3151C11.2373 18.596 11.9877 17.9521 11.9877 17.158V0.00538856M8.65662 15.8317H3.34338V9.78876H8.65662V15.8317Z"
                fill="#05668D"
            />
        </svg>
    );
};

export default LogoIcon;
